(() => {
  'use strict';

  const drawer = document.querySelector('[data-muah-cart]');
  if (!drawer) return;

  const body = drawer.querySelector('[data-muah-cart-body]');
  const footer = drawer.querySelector('[data-muah-cart-footer]');
  const subtotalEl = drawer.querySelector('[data-muah-cart-subtotal]');
  const countTextEl = drawer.querySelector('[data-muah-cart-count-text]');
  const shippingWrap = drawer.querySelector('[data-muah-shipping]');
  const shippingFill = drawer.querySelector('[data-muah-shipping-fill]');
  const shippingTruck = drawer.querySelector('[data-muah-shipping-truck]');
  const shippingMsg = drawer.querySelector('[data-muah-shipping-msg]');
  const shippingLine = drawer.querySelector('[data-muah-cart-shipping-line]');
  const discountForm = drawer.querySelector('[data-muah-discount-form]');
  const discountInput = drawer.querySelector('[data-muah-discount-input]');
  const discountStatus = drawer.querySelector('[data-muah-discount-status]');

  const THRESHOLD = parseInt(drawer.dataset.shippingThreshold, 10) || 4990;

  // Texte aus snippets/muah-i18n-js.liquid (window.MUAH_T), deutscher Fallback.
  // ROOT = sprachabhaengiger Shop-Pfad ('/' bzw. '/en/'), damit Ajax-Antworten in der Shopsprache kommen.
  const T = (k, fb) => (window.MUAH_T && window.MUAH_T[k]) || fb;
  const ROOT = window.MUAH_ROOT || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Builder-Produkte ("Mix & Save Box") im Warenkorb gruppiert anzeigen
  const GROUP_PROP = 'Paket';
  const GROUP_VAL = 'Mix & Save Box';
  const isGroupItem = (it) => it.properties && it.properties[GROUP_PROP] === GROUP_VAL;

  // Produktbild für die Mix & Save-Gruppe: dasselbe Bild wie in der Menü-Sektion
  // "Bau dir deine Box" (transparentes PNG) auf Markenhintergrund #922D39.
  const scriptEl = document.querySelector('script[src*="muah-cart.js"]');
  const BUNDLE_IMG = scriptEl ? scriptEl.src.replace(/muah-cart\.js(\?.*)?$/, 'muah-menu-bundle.png') : '';

  const GROUP_CSS = `
.muah-cart__group{list-style:none;border:1px solid var(--muah-border,#ECE0CE);border-radius:14px;padding:12px 12px 4px;margin:0 0 14px;background:rgba(232,93,24,.045);}
.muah-cart__group-head{display:flex;align-items:center;gap:12px;margin-bottom:8px;padding:2px;}
.muah-cart__group-thumb{flex:none;width:54px;height:54px;border-radius:12px;background-color:#922D39;background-position:center;background-repeat:no-repeat;background-size:contain;}
.muah-cart__group-txt{display:flex;flex-direction:column;gap:2px;min-width:0;}
.muah-cart__group-title{font-weight:800;font-size:15px;color:var(--muah-accent,#E85D18);line-height:1.15;}
.muah-cart__group-meta{font-size:12px;font-weight:600;color:#8A7C74;}
.muah-cart__group-lines{list-style:none;margin:0;padding:0;}
.muah-cart__group .muah-cart__line{border-bottom:1px solid rgba(236,224,206,.7);}
.muah-cart__group .muah-cart__line:last-child{border-bottom:0;}
`;
  const styleTag = document.createElement('style');
  styleTag.textContent = GROUP_CSS;
  document.head.appendChild(styleTag);

  const fmtMoney = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')} €`;

  // Kleines Thumbnail über Shopifys ?width=-Parameter (funktioniert mit und ohne ?v=-Query,
  // anders als ein _200x-Replace, das an CDN-URLs mit Query-String scheitert).
  const thumb = (url) => url ? url + (url.includes('?') ? '&' : '?') + 'width=160' : '';

  let closeTimer;

  const escapeHtml = (s) => String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const openCart = () => {
    clearTimeout(closeTimer); // verhindert, dass ein laufender Close-Timeout den gerade geöffneten Drawer wieder versteckt
    drawer.hidden = false;
    drawer.offsetHeight;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('muah-no-scroll');
  };
  const closeCart = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('muah-no-scroll');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => { drawer.hidden = true; }, 320);
  };

  document.addEventListener('muah:cart:open', () => { openCart(); fetchCart().then(renderCart).catch(() => {}); });
  drawer.querySelectorAll('[data-muah-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
  });

  const lineTemplate = (item) => `
    <li class="muah-cart__line" data-muah-line-key="${item.key}">
      <a href="${item.url}" class="muah-cart__line-img">
        ${item.image ? `<img src="${thumb(item.image)}" alt="${escapeHtml(item.title)}" width="80" height="80" loading="lazy">` : ''}
      </a>
      <div class="muah-cart__line-info">
        <a href="${item.url}" class="muah-cart__line-title">${escapeHtml(item.product_title)}</a>
        ${item.variant_title && !item.variant_title.includes('Default') ? `<span class="muah-cart__line-variant">${escapeHtml(item.variant_title)}</span>` : ''}
        <span class="muah-cart__line-price">${fmtMoney(item.final_line_price)}</span>
        <div class="muah-cart__line-actions">
          <div class="muah-cart__qty">
            <button type="button" class="muah-cart__qty-btn" data-muah-qty-decrease data-line-key="${item.key}" aria-label="${escapeHtml(T('qty_decrease', 'Anzahl verringern'))}">−</button>
            <span class="muah-cart__qty-val" data-muah-qty-val>${item.quantity}</span>
            <button type="button" class="muah-cart__qty-btn" data-muah-qty-increase data-line-key="${item.key}" aria-label="${escapeHtml(T('qty_increase', 'Anzahl erhöhen'))}">+</button>
          </div>
          <button type="button" class="muah-cart__line-remove" data-muah-line-remove data-line-key="${item.key}" aria-label="${escapeHtml(T('remove', 'Entfernen'))}">✕</button>
        </div>
      </div>
    </li>
  `;

  // Zeilen aufbauen: Mix & Save Box-Artikel in eine Gruppe, der Rest normal darunter
  const buildLines = (items) => {
    const grp = items.filter(isGroupItem);
    const rest = items.filter((it) => !isGroupItem(it));
    let html = '';
    if (grp.length) {
      const cnt = grp.reduce((s, it) => s + it.quantity, 0);
      const tot = grp.reduce((s, it) => s + it.final_line_price, 0);
      html += `<li class="muah-cart__group"><div class="muah-cart__group-head"><span class="muah-cart__group-thumb"${BUNDLE_IMG ? ` style="background-image:url('${BUNDLE_IMG}')"` : ''}></span><div class="muah-cart__group-txt"><span class="muah-cart__group-title">${escapeHtml(T('group_title', GROUP_VAL))}</span><span class="muah-cart__group-meta">${escapeHtml((cnt === 1 ? T('group_count_one', '[count] Produkt') : T('group_count_other', '[count] Produkte')).replace('[count]', cnt))} · ${fmtMoney(tot)}</span></div></div><ul class="muah-cart__group-lines" role="list">${grp.map(lineTemplate).join('')}</ul></li>`;
    }
    html += rest.map(lineTemplate).join('');
    return html;
  };

  const updateShippingBar = (totalCents) => {
    if (!shippingWrap) return;
    const pct = Math.min(100, Math.round((totalCents / THRESHOLD) * 100));
    const reached = totalCents >= THRESHOLD;
    if (shippingFill) {
      shippingFill.style.width = pct + '%';
      shippingFill.classList.toggle('is-complete', reached);
    }
    if (shippingTruck) {
      shippingTruck.style.left = pct + '%';
      shippingTruck.classList.toggle('is-complete', reached);
    }
    if (shippingMsg) {
      const remaining = THRESHOLD - totalCents;
      shippingMsg.innerHTML = reached
        ? '🎉 ' + escapeHtml(T('shipping_unlocked', 'Du hast kostenlosen Versand gesichert!'))
        : T('shipping_remaining_html', 'Nur noch <strong>[amount]</strong> zum kostenlosen Versand!').replace('[amount]', fmtMoney(remaining));
    }
    if (shippingLine) {
      shippingLine.innerHTML = reached
        ? escapeHtml(T('shipping_label', 'Versand:')) + ' <strong>' + escapeHtml(T('shipping_free', 'Kostenlos')) + '</strong>'
        : escapeHtml(T('shipping_de_label', 'Versandkosten Deutschland:')) + ' <strong>4,90 €</strong>';
    }
  };

  // silent: Stand kommt von außen (z. B. Warenkorbseite), dann kein erneutes Update-Event auslösen.
  const renderCart = (cart, opts) => {
    // Fehlerantworten von /cart/change.js (z.B. 422 über Lagerbestand) haben kein items-Array
    // -> nicht rendern, sonst crasht buildLines(cart.items).
    if (!cart || !Array.isArray(cart.items)) return;

    if (countTextEl) countTextEl.textContent = `(${cart.item_count})`;
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="muah-cart__empty">
          <h3>${escapeHtml(T('empty_title', 'Dein Warenkorb ist leer'))}</h3>
          <p>${escapeHtml(T('empty_sub', 'Stöbere durch unsere Sorten und finde deinen neuen Lieblings-Genuss.'))}</p>
          <a href="${ROOT}collections/bestseller" class="muah-btn muah-btn--primary muah-btn--lg" data-muah-cart-close>${escapeHtml(T('empty_cta', 'Bestseller entdecken'))}</a>
        </div>
      `;
      if (footer) footer.hidden = true;
      if (shippingWrap) shippingWrap.hidden = true;
    } else {
      const linesEl = body.querySelector('[data-muah-cart-lines]');
      if (linesEl) {
        linesEl.innerHTML = buildLines(cart.items);
      } else {
        const cross = body.querySelector('.muah-cart__cross');
        body.innerHTML = `<ul class="muah-cart__lines" data-muah-cart-lines role="list">${buildLines(cart.items)}</ul>` + (cross ? cross.outerHTML : '');
      }
      if (footer) footer.hidden = false;
      if (shippingWrap) shippingWrap.hidden = false;
    }

    updateShippingBar(cart.total_price);

    body.querySelectorAll('[data-muah-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
    bindLineActions();

    if (opts && opts.silent) return;
    const detail = Object.assign({}, cart, { source: 'drawer' });
    delete detail.sections;
    document.dispatchEvent(new CustomEvent('muah:cart:updated', { detail }));
  };

  // Änderungen der Warenkorbseite (cart.js) in die Schublade übernehmen (gleiche Serverantwort).
  document.addEventListener('muah:cart:updated', (e) => {
    const d = e.detail;
    if (!d || d.source === 'drawer' || !Array.isArray(d.items)) return;
    renderCart(d, { silent: true });
  });

  const fetchCart = () => fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());

  const addToCart = (formData) => fetch(ROOT + 'cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: formData
  }).then((r) => r.json()).then((res) => {
    if (res.status >= 400) throw res;
    return fetchCart();
  }).then(renderCart);

  const notifyError = (msg) => {
    if (window.muahToast) window.muahToast(msg || T('qty_error', 'Die Menge konnte nicht geändert werden.'), { type: 'error' });
  };

  // Mehrfachklick-Schutz: immer nur eine Anfrage gleichzeitig; weitere Klicks werden gesammelt
  // (pro Position zählt der letzte Wunschwert) und nach Abschluss der laufenden Anfrage gesendet.
  const pendingQty = new Map();
  let qtyInFlight = false;

  const changeQty = (key, qty) => fetch(ROOT + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then((r) => r.json()).then((cart) => {
    // Bei Fehler (kein items-Array) frischen Cart-Stand nachladen statt kaputt zu rendern
    if (!cart || !Array.isArray(cart.items)) {
      notifyError(cart && typeof cart.description === 'string' ? cart.description : '');
      return fetchCart().then((c) => renderCart(c));
    }
    // Stehen schon weitere Änderungen an, erst deren Antwort darstellen.
    if (pendingQty.size === 0) renderCart(cart);
  }).catch(() => fetchCart().then((c) => renderCart(c)).catch(() => {}));

  const flushQty = () => {
    const next = pendingQty.entries().next();
    if (next.done) {
      qtyInFlight = false;
      drawer.removeAttribute('aria-busy');
      return;
    }
    const [key, qty] = next.value;
    pendingQty.delete(key);
    qtyInFlight = true;
    drawer.setAttribute('aria-busy', 'true');
    changeQty(key, qty).finally(flushQty);
  };

  const requestQty = (key, qty) => {
    pendingQty.set(key, qty);
    if (!qtyInFlight) flushQty();
  };

  const applyDiscount = async (code) => {
    if (!code) return;
    const trimmed = code.trim();
    if (!trimmed) return;
    if (discountStatus) {
      discountStatus.hidden = false;
      discountStatus.classList.remove('is-error', 'is-success');
      discountStatus.textContent = T('discount_checking', 'Wird geprüft …');
    }
    try {
      const r = await fetch(ROOT + 'discount/' + encodeURIComponent(trimmed), { redirect: 'follow' });
      if (discountStatus) {
        discountStatus.classList.add('is-success');
        discountStatus.innerHTML = T('discount_pending_html', 'Code <strong>[code]</strong> wird an der Kasse geprüft.').replace('[code]', escapeHtml(trimmed));
      }
      const cart = await fetchCart();
      renderCart(cart);
    } catch (err) {
      if (discountStatus) {
        discountStatus.classList.add('is-error');
        discountStatus.textContent = T('discount_failed', 'Code konnte nicht angewendet werden.');
      }
    }
  };

  if (discountForm) {
    discountForm.addEventListener('submit', (e) => {
      e.preventDefault();
      applyDiscount(discountInput.value);
    });
  }

  const bindLineActions = () => {
    // Angezeigte Menge sofort anpassen, damit schnelle Mehrfachklicks korrekt zählen.
    drawer.querySelectorAll('[data-muah-qty-decrease]:not([data-muah-bound])').forEach((btn) => {
      btn.dataset.muahBound = 'true';
      btn.addEventListener('click', () => {
        const key = btn.dataset.lineKey;
        const valEl = btn.nextElementSibling;
        const cur = parseInt(valEl.textContent, 10) || 1;
        const qty = Math.max(0, cur - 1);
        valEl.textContent = String(qty);
        requestQty(key, qty);
      });
    });
    drawer.querySelectorAll('[data-muah-qty-increase]:not([data-muah-bound])').forEach((btn) => {
      btn.dataset.muahBound = 'true';
      btn.addEventListener('click', () => {
        const key = btn.dataset.lineKey;
        const valEl = btn.previousElementSibling;
        const cur = parseInt(valEl.textContent, 10) || 0;
        const qty = cur + 1;
        valEl.textContent = String(qty);
        requestQty(key, qty);
      });
    });
    drawer.querySelectorAll('[data-muah-line-remove]:not([data-muah-bound])').forEach((btn) => {
      btn.dataset.muahBound = 'true';
      btn.addEventListener('click', () => {
        const line = btn.closest('[data-muah-line-key]');
        if (line) line.style.opacity = '0.5';
        requestQty(btn.dataset.lineKey, 0);
      });
    });
  };

  const bindAddForms = () => {
    document.querySelectorAll('[data-muah-pcard-form]:not([data-muah-bound])').forEach((form) => {
      form.dataset.muahBound = 'true';
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        const orig = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }
        try {
          await addToCart(new FormData(form));
          openCart();
        } catch (err) {
          console.error('Add to cart failed:', err);
          alert((err && err.description) || T('add_failed', 'Konnte nicht in den Warenkorb hinzufügen.'));
        } finally {
          if (btn) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = orig; }
        }
      });
    });
  };

  bindAddForms();
  // Entprellt: statt bei jeder DOM-Mutation sofort das ganze Dokument abzufragen,
  // pro Frame nur einmal neu binden (Apps/Slideshows mutieren den DOM laufend).
  let bindScheduled = false;
  const scheduleBind = () => {
    if (bindScheduled) return;
    bindScheduled = true;
    requestAnimationFrame(() => { bindScheduled = false; bindAddForms(); });
  };
  const observer = new MutationObserver(scheduleBind);
  observer.observe(document.body, { childList: true, subtree: true });

  bindLineActions();
  fetchCart().then((cart) => {
    if (cart) updateShippingBar(cart.total_price);
  }).catch(() => {});
})();
